import {ServersDrawerItem} from "./ServersDrawerItem";
import {ServersContent} from "./ServersContent";
import {DrawerItemData} from "../../app/types";

export const ServersComponent: DrawerItemData = {
    uid: "servers",
    drawerItem: ServersDrawerItem,
    content: ServersContent
};
